import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useOrdersResource, {
  VerifyOrderResponse,
} from "../../../resources/useOrdersResource";

const Return = () => {
  const { verifyOrder } = useOrdersResource();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading"
  );

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");
    const orderId = localStorage.getItem("order_id");

    if (!sessionId) {
      setStatus("error");
      setTimeout(() => navigate("/sangati"), 3000);
      return;
    }

    if (!orderId) {
      setStatus("error");
      setTimeout(() => navigate("/sangati"), 3000);
      return;
    }

    verifyOrder(orderId, { session_id: sessionId })
      .then((response: VerifyOrderResponse) => {
        if (!response) {
          setStatus("error");
          setTimeout(() => navigate("/sangati"), 3000);
          return;
        }

        setStatus("success");
        localStorage.removeItem("order_id");
        setTimeout(() => navigate("/sangati"), 2000);
      })
      .catch(() => {
        setStatus("error");
        setTimeout(() => navigate("/sangati"), 3000);
      });
  }, [navigate, verifyOrder, t]);

  return (
    <section
      id="payment-status"
      className="flex items-center justify-center min-h-screen bg-bg-grey"
    >
      <div className="text-center p-8 bg-white85 rounded-lg shadow-md max-w-md mx-auto">
        {status === "loading" && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sangati-green mx-auto mb-4"></div>
          </>
        )}

        {status === "success" && (
          <>
            <div className="text-green-500 mb-4">
              <svg
                className="w-16 h-16 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              {t("purchased")}
            </h2>
          </>
        )}

        {status === "error" && (
          <>
            <div className="text-red-500 mb-4">
              <svg
                className="w-16 h-16 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              {t("paymentFailedToast")}
            </h2>
            <button
              onClick={() => navigate("/sangati")}
              className="px-4 py-2 bg-sangati-green text-white rounded hover:bg-green-600 transition-colors"
            >
              {t("back")}
            </button>
          </>
        )}
      </div>
    </section>
  );
};

export default Return;
